/**
 * Non-secret UX hint: the phone number from the most recent successful login.
 * Used to pre-fill the login field after logout (passkey hints are per-device
 * and may belong to a different account than the last session).
 */
const LAST_LOGIN_PHONE_KEY = 'last_login_phone'

/**
 * @param {string} phone E.164 or normalizable phone
 */
export function setLastLoginPhone(phone) {
  if (!phone) return
  try {
    localStorage.setItem(LAST_LOGIN_PHONE_KEY, String(phone).trim())
  } catch { /* ignore */ }
}

/**
 * @returns {string|null}
 */
export function getLastLoginPhone() {
  try {
    const v = localStorage.getItem(LAST_LOGIN_PHONE_KEY)
    return v && v.trim() ? v.trim() : null
  } catch {
    return null
  }
}
